/**
 * Where "Apply to join" goes.
 *
 * ⚠️  CARRIED OVER VERBATIM from the page this replaces — every CTA on the old
 * ambassador page opened this exact Typeform in a new tab, and that is the whole
 * conversion path for the programme. It is not a placeholder.
 */
const APPLY_URL = "https://form.typeform.com/to/apa5FqDW?typeform-source=amberstudent.com";

export default APPLY_URL;
